import { useTranslation } from 'next-i18next';
import { Accept } from 'react-dropzone/.';
import * as yup from 'yup';

export const useChatInput = () => {
  const { t } = useTranslation();

  // defines the list of types the file dialog allows
  const supportedFiles: Accept = {
    'application/pdf': ['.pdf'],
    // 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
    //   '.docx',
    // ],
    'application/vnd.ms-excel': ['.xls'],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
      '.xlsx',
    ],
    'text/csv': ['.csv'],
    'text/markdown': ['.md'],
    'text/plain': ['.txt'],
    'image/jpeg': ['.jpg', '.jpeg'],
    'image/png': ['.png'],
  };

  const validateFileExtension = (fileName: string) => {
    const formats = Object.values(supportedFiles).flatMap((types) => types);
    const extension = fileName.split('.').pop();
    return extension ? formats.includes(`.${extension}`) : false;
  };

  const chatInputSchema: yup.SchemaOf<ChatInputForm> = yup
    .object()
    .shape({
      message: yup.string(),
      file: yup
        .mixed()
        .test('fileFormat', t('unsupported-file-format'), (file: File) =>
          file ? validateFileExtension(file.name) : true
        )
        .test('fileSize', t('file-too-large', { max: 5 }), (file: File) =>
          file ? file.size <= 5000000 : true
        ),
    })
    .test(
      'messageOrFile',
      t('either-message-or-file-required'),
      function (value) {
        return !!value?.message || !!value?.file;
      }
    );

  return { supportedFiles, chatInputSchema, validateFileExtension };
};
